export interface Tomo {
  num: string
  title: string
  desc: string
  cover: string
}

export const TOMOS: Tomo[] = [
  {
    num: '1',
    title: 'El ojo clínico',
    desc: 'Qué observar primero para no pasar nada por alto.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e86731b3-b32a-48dd-a366-eaed7a2920f3.jpg',
  },
  {
    num: '2',
    title: 'Destreza técnica',
    desc: 'El paso a paso para ejecutar con seguridad.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/609facbc-8253-41d7-aa82-56ddd55e3cc6.jpg',
  },
  {
    num: '3',
    title: 'Gestión del turno',
    desc: 'Cómo organizar prioridades durante la jornada.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a91bd7b5-ddee-406a-90c9-197f08070789.jpg',
  },
  {
    num: '4',
    title: 'Deterioro y actuación rápida',
    desc: 'Detección temprana y qué hacer en los primeros minutos.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/9572314c-dd40-4e0e-b9bc-9ca86d7897de.jpg',
  },
  {
    num: '5',
    title: 'Blindaje en medicación',
    desc: 'Dosis, cálculos y control de errores frecuentes.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c53e974b-bbce-48cc-8ee8-87671f99f2b6.jpg',
  },
  {
    num: '6',
    title: 'Criterio profesional',
    desc: 'Casos resueltos para decidir con fundamento.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d7102ad8-3f87-4def-86f8-aa3454c81ef5.jpg',
  },
]
